import { ref } from 'vue'

function formatPhone(value: string): string {
  let cleaned = value.replace(/[^\d+]/g, '')

  if (!cleaned.startsWith('+7')) {
    cleaned = '+7' + cleaned.substring(cleaned.startsWith('+') ? 1 : 0)
  }

  if (cleaned.length > 12) {
    cleaned = cleaned.slice(0, 12)
  }

  if (cleaned.length > 2) {
    let formatted = cleaned.substring(0, 2)
    if (cleaned.length > 2) formatted += ' ' + cleaned.substring(2, 5)
    if (cleaned.length > 5) formatted += ' ' + cleaned.substring(5, 8)
    if (cleaned.length > 8) formatted += '-' + cleaned.substring(8, 10)
    if (cleaned.length > 10) formatted += '-' + cleaned.substring(10)
    cleaned = formatted
  }

  return cleaned
}

export function usePhoneInput(initial = '+7') {
  const phone = ref(initial)

  const handleInput = (event: Event): void => {
    phone.value = formatPhone((event.target as HTMLInputElement).value)
  }

  return { phone, handleInput }
}
